// extracted by mini-css-extract-plugin
module.exports = {"ask":"e_V3","title":"e_W3","text":"e_X3","cta":"e_Y3"};